import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectCurrentAlarm } from './alarm-store/alarm.selector';
import { AlarmComponent } from './alarm.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-alarm',
  templateUrl: './alarm.container.html',
  imports: [AlarmComponent],
})
export class AlarmContainerComponent {
  private readonly store = inject(Store);

  public readonly currentAlarm = this.store.selectSignal(selectCurrentAlarm);
}
